import React, { useEffect, useState } from 'react'
import { getBalanceReport, getHorizontalBalanceSheetReport } from '_services/reportService/reportService'
import { CommonDateRange } from 'components'
import moment from 'moment'
import { BsDownload, BsPencil } from 'react-icons/bs'
import { FiRefreshCcw } from 'react-icons/fi'
import StorageService from 'utils/StorageServices/StorageServices'
import { utils } from 'helper'

const HorizontalBalanceSheet = () => {

    const [horizontalBalanceSheetData, setHorizontalBalanceSheetData] = useState({});
    const [loading, setLoading] = useState(false);
    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
    };

    useEffect(() => {
        getHorizontalBalanceSheetList()
    }, [selectedRange])

    const getHorizontalBalanceSheetList = async () => {
        setLoading(true)
        const payload = {
            company_id: StorageService.getCompanyId(),
            start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        }
        try {
            const res = await getHorizontalBalanceSheetReport(payload);
            if (res?.responseCode == 200) {
                setHorizontalBalanceSheetData(res?.data)
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const resetFunction = () => {
        const newStartDate = moment().startOf('month');
        const newEndDate = moment().endOf('month');

        setSelectedRange({
            startDate: newStartDate,
            endDate: newEndDate,
        });
    };

    return (
        <>
            <div className='__znDe_mainBx'>
                <div>
                    <div className='panel-heading'>
                        <h2><span>Horizontal Balance Sheet</span></h2>

                        <div className='panel-ctrls report-control'>
                            <div>
                                <CommonDateRange
                                    key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                    initialStartDate={selectedRange.startDate}
                                    initialEndDate={selectedRange.endDate}
                                    onApply={handleApply}
                                />
                            </div>

                            <button className='__bxs_srBtn'>
                                <BsDownload />
                            </button>


                            <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                                <FiRefreshCcw />
                            </button>
                        </div>
                    </div>
                </div>

                <div className='__hrlMain_dix'>
                    <div className='voucher report-voucher report-h printable'>
                        <div className='__mainPanel'>
                            <div className="panel panel-primary">
                                <div className='panel-body '>
                                    <div className='py-20 block-ui block-ui-anim-fade'>
                                        <div className='clear-both text-center p-10'>
                                            <div class="__hrlMx_head" >
                                                <p>{horizontalBalanceSheetData?.company?.company ? horizontalBalanceSheetData?.company?.company : '-'}</p>
                                                <h4>Horizontal Balance Sheet</h4>
                                                <h5><span>Basis</span> : Accrual</h5>
                                                <h5>As of {horizontalBalanceSheetData?.start_date ? utils.getDateByApiResponse(horizontalBalanceSheetData?.start_date) : ""}</h5>
                                            </div>
                                        </div>

                                        <div className='clear-both'>
                                           {loading ? <span className='m-5 commonCenter_avt'> Loading... </span> : <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> Liabilities & Equity </div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'> {horizontalBalanceSheetData?.start_date ? utils.getDateByApiResponse(horizontalBalanceSheetData?.start_date) : ""} </div>
                                                                </div>
                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item text-left'>Liabilities</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                    </div>
                                                                </div>
                                                                {horizontalBalanceSheetData?.Liabilities?.liabilities?.map((item, itemIndex) => {
                                                                    return (
                                                                        <React.Fragment key={itemIndex}>
                                                                            <div className='subHead'>
                                                                                <div className='highlight-row'>
                                                                                    <div className='rpt-cell rpt-col-item text-left'> &nbsp; {item?.name}</div>
                                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                    <div className='rpt-cell rpt-col-qty text-end'>{item?.balance}</div>
                                                                                </div>
                                                                                {item?.accounts?.map((el, idx) => {
                                                                                    return (
                                                                                        <React.Fragment key={idx}>
                                                                                            <div className='clickable-row'>
                                                                                                <div className='rpt-cell rpt-col-item pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end rw-btm-border'>{el?.balance ? el?.balance : 0}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <div className='report-table w-100 bl '>
                                                                    <div className='row-total'>
                                                                        <div className='rpt-cell rpt-col-item text-left'> Total Liabilities </div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>{horizontalBalanceSheetData?.Liabilities?.total_liabilities ? horizontalBalanceSheetData?.Liabilities?.total_liabilities : ''} </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='report-table w-100 bl '>
                                                                {horizontalBalanceSheetData?.Equity?.equity?.map((item, itemIndex) => {
                                                                    return (
                                                                        <React.Fragment key={itemIndex}>
                                                                            <div className='subHead'>
                                                                                <div className='highlight-row'>
                                                                                    <div className='rpt-cell rpt-col-item text-left'>{item?.name}</div>
                                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                </div>
                                                                                {item?.accounts?.map((el, idx) => {
                                                                                    return (
                                                                                        <React.Fragment key={idx}>
                                                                                            <div className='clickable-row'>
                                                                                                <div className='rpt-cell rpt-col-item pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end rw-btm-border'>{el?.balance ? el?.balance : 0}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })}
                                                                                <div className='report-table w-100 bl '>
                                                                                    <div className='row-total'>
                                                                                        <div className='rpt-cell rpt-col-item text-left'> Total Equity </div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'> {horizontalBalanceSheetData?.Equity?.total_equity} </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='report-table w-100 bl '>
                                                                                    <div className='row-total'>
                                                                                        <div className='rpt-cell rpt-col-item text-left'> Total Liabilities Equity  </div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'>{horizontalBalanceSheetData?.total_liabilities_equity} </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> Assets </div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'> {horizontalBalanceSheetData?.start_date ? utils.getDateByApiResponse(horizontalBalanceSheetData?.start_date) : ""} </div>
                                                                </div>

                                                                {horizontalBalanceSheetData?.Assets?.assets?.map((item, itemIndex) => {
                                                                    return (
                                                                        <React.Fragment key={itemIndex}>
                                                                            <div className='subHead'>
                                                                                <div className='highlight-row'>
                                                                                    <div className='rpt-cell rpt-col-item text-left'>{item?.name}</div>
                                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                    <div className='rpt-cell rpt-col-qty text-end'>{item?.balance}</div>
                                                                                </div>
                                                                                {item?.accounts?.map((el, idx) => {
                                                                                    return (
                                                                                        <React.Fragment key={idx}>
                                                                                            <div className='clickable-row'>
                                                                                                <div className='rpt-cell rpt-col-item pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end rw-btm-border'>{el?.balance ? el?.balance : 0}</div>
                                                                                                <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })}
                                                                                <div className='report-table w-100 bl '>
                                                                                    <div className='row-total'>
                                                                                        <div className='rpt-cell rpt-col-item text-left'> Total {item?.name} </div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                        <div className='rpt-cell rpt-col-qty text-end'> {item?.balance}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <div className='report-table w-100 bl '>
                                                                    <div className='row-total'>
                                                                        <div className='rpt-cell rpt-col-item text-left'> Total Assets </div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'> {horizontalBalanceSheetData?.Assets?.total_assets ? horizontalBalanceSheetData?.Assets?.total_assets : ''}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HorizontalBalanceSheet